module.exports = __webpack_public_path__ + "img/pt_flag.c7286f42.svg";